import { render, staticRenderFns } from "./TruckingJob.vue?vue&type=template&id=21c4ffd8&scoped=true&"
import script from "./TruckingJob.vue?vue&type=script&lang=js&"
export * from "./TruckingJob.vue?vue&type=script&lang=js&"
import style0 from "./TruckingJob.vue?vue&type=style&index=0&id=21c4ffd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4ffd8",
  null
  
)

export default component.exports